function fn_part_side_form() {
    var $fn = $(".side_form")

    if ($fn.length) {
        $fn.on("click","[data-side-toggle]",function (e) {
            e.preventDefault();
            $fn.toggleClass("active");
        })
    }
}